
import { Component, Vue } from "vue-property-decorator";
import { Api } from "shared/api";
import { apiHandler } from "@/services/api-handler";
import { IAlert } from "shared/entities/alert";
import * as icons from "@fortawesome/free-solid-svg-icons";

@Component({})
export default class Alerts extends Vue {
    icons = icons;
    newAlert: Partial<IAlert> = {
        message: "",
        creationDate: new Date(),
        expirationDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
    };


    currentAlerts: IAlert[] = []; // Add this line

    async mounted() {
        await this.loadCurrentAlerts();
    }

    async createAlert() {
        if (!this.newAlert.message) {
            alert("Please enter an alert message.");
            return;
        }
        // Check if the message length is greater than 5000 characters test
    if (this.newAlert.message.length > 5000) {
        alert("Your alert is too long. Please submit a shorter alert.");
        return;
    }

        await apiHandler(() => Api.alerts.Post(this.newAlert as IAlert));
        alert("Alert has been created.");
        this.newAlert.message = "";
        await this.loadCurrentAlerts();
    }

    async loadCurrentAlerts() {
    try {
        await this.deleteExpiredAlerts(); // Delete expired alerts first
        const alerts = await Api.alerts.Get();
        this.currentAlerts = alerts; // Display all remaining alerts
    } catch (error) {
        // eslint-disable-next-line
        console.error("Error fetching alerts:", error);
    }
}

async deleteExpiredAlerts() {
    try {
        const allAlerts = await Api.alerts.Get();
        const today = new Date();

        for (const alert of allAlerts) {
            const expirationDate = new Date(alert.expirationDate);
            if (expirationDate < today) {
                await apiHandler(() => Api.alerts[alert.id].Delete());
            }
        }
    } catch (error) {
        // eslint-disable-next-line
        console.error("Error processing expired alerts:", error);
    }
}



customFormatter(date: Date): string {
        return date.toISOString().substring(0, 10);
    }

async deleteAlert(id: string) {
    if (window.confirm("Are you sure you want to delete this alert?")) {
        try {
            const response = await apiHandler(() => Api.alerts[id].Delete());
            alert("Alert has been deleted."); // Notify the user
            await this.loadCurrentAlerts(); // Refresh the list after deleting an alert
        } catch (error) {
            // eslint-disable-next-line
            console.error("Error deleting alert:", error);
        }
    }
}

}
